import { render, staticRenderFns } from "./VehiculoForm.vue?vue&type=template&id=502002b0"
import script from "./VehiculoForm.vue?vue&type=script&lang=ts"
export * from "./VehiculoForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports